import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { logoutService } from './Logout.services';

@Component
export default class Logout extends Vue{
    public fullPage:Boolean = false;
    public $loading: any
    constructor(){
        super();
    }
    public data(){
        return {

        }
    }
    mounted():void{
        console.log("logout mounted");
        console.log(this.$store.getters.getLoginToken['token']);
        let token_key = localStorage.getItem("token");
        let data = {token:token_key}
        this.logout(data);
    }

    addLoginToken(loginToken: any) {
        this.$store.dispatch("addLoginToken", loginToken);
    }
    logOut():void{
        this.$store.dispatch("logOut");
    }

    changeLoggedInStatus(){
        this.$store.dispatch("changeLoggedInStatus");
      }

    public async logout(data:any):Promise<void>{

        let loader = this.$loading.show({
            // Optional parameters
            container: this.fullPage ? null : this.$refs.formContainer,
            canCancel: false,
            // onCancel: this.onCancel,
          });
  
        let postData = {data:data}
        const res = logoutService.logout(postData).
        then((response:any) =>{
            loader.hide();
            this.logOut();
            this.$router.push('login');            
        }).catch((error: any) =>{
            console.log(error);
            loader.hide();
            this.$router.push('login');
        });
    }
}